import {combineReducers} from "redux";
import create from './create';
import deleteCategory from './delete';
import deleteSelection from "./deleteSelection";
import list from "./list";
import update from './update';
import updatePosition from "./updatePosition";

export default combineReducers({ create, deleteCategory, deleteSelection, list, update, updatePosition });
